<template>
  <custom-callout :has-toggle="false" class="mt-2" border-color="gray-2">
    <div class="row">
      <div class="col-md-4 pt-0">
        <div class="text-gray">
          Tipo de Referido:
        </div>
        <div class="text-description">
          {{ item.referralType }}
        </div>
      </div>
      <div class="col-md-3 mt-2 mt-md-0">
        <div class="text-gray">
          Equipo:
        </div>
        <div class="text-description">
          {{ item.equipment }}
        </div>
      </div>
      <div class="col-md-4 mt-2 mt-md-0">
        <div class="text-gray">
          Tipo de Servicio:
        </div>
        <div class="text-description">
          {{ item.serviceType.name }}
        </div>
      </div>
      <div class="col-md-1 pt-1 text-right mt-2 mt-md-0" v-if="!readOnly">
        <action-button
          variant="outline-danger"
          class="w-md-100"
          i="fas fa-times-circle"
          @click="deleteItem()"
        />
      </div>
    </div>
  </custom-callout>
</template>

<script>
import mixAlert from "@/mixin/alert.mixin";
import CustomCallout from "custom-callout";
import ActionButton from "ActionButton";

export default {
  name: "EquipmentRow",
  components: {
    CustomCallout,
    ActionButton
  },
  props: {
    readOnly: {
      type: Boolean,
      default: false
    },
    index: {
      type: Number,
      default: 0
    },
    item: {
      type: Object,
      require: true,
      default: () => {}
    }
  },
  mixins: [mixAlert],
  methods: {
    deleteItem() {
      this.$emit("delete", { index: this.index, item: this.item });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/assets/scss/variables/_colors.scss";
::v-deep .bg-secondary-3 {
  background-color: map-get($colors, "gray-1");
}
</style>
